import React from "react";

class SfErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // logErrorToMyService(error, errorInfo);
    // alert(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: "#900", marginTop: "30px", marginLeft: "30px" }}>
          Oops! Something went wrong... Please, reload this page
        </div>
      );
    }

    return this.props.children;
  }
}

export default SfErrorBoundary;
